import { takeLatest, put, call } from 'redux-saga/effects'
import * as actions from '../slices/index'

import Auth from '../../api/auth'
import constants from '../../constants'

export function* getUserDetailsSaga(action) {
  try {
    const response = yield call(Auth.getUserDetails, action.payload)
    if (response?.code == 1) {
      yield put(actions.getUserDetailsSuccess(response?.data))
    } else {
      yield put(
        actions.getUserDetailsError(response?.message || constants.ERROR_MSG),
      )
    }
  } catch (error) {
    yield put(actions.getUserDetailsError(constants.ERROR_MSG))
  }
}

export function* authenticationSaga() {
  yield takeLatest(actions.getUserDetailsRequest, getUserDetailsSaga)
}
